module.exports = __webpack_public_path__ + "static/img/1_9_1.cb2fedd3.jpg";